import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase";

export const useFirestoreOrderedList = (collectionName) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const q = query(collection(db, collectionName), orderBy("order", "asc"));

      const snap = await getDocs(q);

      const data = snap.docs.map((doc) => {
        const d = doc.data();
        return {
          id: doc.id,
          ...d,
          eventdate:
            d.eventdate instanceof Timestamp
              ? d.eventdate.toDate().toLocaleString()
              : d.eventdate,
        };
      });

      setList(data);
    };

    fetch();
  }, [collectionName]);

  return list;
};
